import axios from "axios";
import { apiBase } from "@/constants";

export default {
  state: {
    token: localStorage.getItem('access-token') || '',
    sessionExpired: false,
    loading: false,
    loadingMessage: '',
    isLoggedIn: !!localStorage.getItem('access-token'),
    formType: 1,
    connectionAuthError: false,
    unknownAuthError: false
  },
  getters: {
    isLoggedIn: state => state.isLoggedIn,
    isAuthenticated: state => !!state.token,
    formType: state => state.formType,
    loading: state => state.loading,
    loadingMessage: state => state.loadingMessage,
    sessionExpired: state => state.sessionExpired,
    connectionAuthError: state => state.connectionAuthError,
    unknownAuthError: state => state.unknownAuthError
  },
  mutations: {
    login(state) {
      state.isLoggedIn = true;
    },
    logout(state) {
      state.isLoggedIn = false;
    },
    setSessionExpired(state, expired) {
      state.sessionExpired = expired;
    },
    proceedToLoginForm(state) {
      state.formType = 1;
    },
    proceedToRegistrationForm(state) {
      state.formType = 2;
    },
    setLoading(state, isLoading) {
      state.loading = isLoading;
    },
    setLoadingMessage(state, message) {
      state.loadingMessage = message;
    },
    setUnknownAuthError(state) {
      state.unknownAuthError = true;
    },
    setConnectionAuthError(state) {
      state.connectionAuthError = true;
    },
    clearAuthErrors(state) {
      state.unknownAuthError = false;
      state.connectionAuthError = false;
    }
  },
  actions: {
    clearAllAuthErrors({ commit }) {
      commit('clearAuthErrors');
      commit('clearLoginErrors');
      commit('clearRegistrationErrors');
    },
    refreshAccesToken: ({ commit }) => new Promise((resolve, reject) => {
      const storageRefreshToken = localStorage.getItem('refresh-token');
      if (storageRefreshToken !== null) {
        axios.post(`${apiBase}/users/tokens/${storageRefreshToken}/refresh`)
          .then((response) => {
            if (response.status === 200) {
              const { accessToken, refreshToken } = response.data;
              localStorage.setItem('access-token', accessToken);
              localStorage.setItem('refresh-token', refreshToken);
              axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
              commit('login');
              resolve(response);
            }
          })
          .catch((err) => {
            localStorage.removeItem('access-token');
            localStorage.removeItem('refresh-token');
            reject(err);
          });
      }
    }),
    logout: ({ commit }) => new Promise((resolve) => {
      localStorage.setItem('remember', false);
      const refreshToken = localStorage.getItem('refresh-token');
      if (refreshToken !== null) {
        axios.post(`${apiBase}/users/tokens/${refreshToken}/revoke`)
          .then((response) => {
            if (response.status === 204) {
              localStorage.removeItem('refresh-token');
            }
          })
          // Remove the refresh token anyway (on the next login refresh token will be replaced)
          .catch(() => { localStorage.removeItem('refresh-token'); });
      }

      axios.post(`${apiBase}/users/tokens/cancel`)
        .then((response) => {
          if (response.status === 204) {
            localStorage.removeItem('access-token');
            delete axios.defaults.headers.common.Authorization;
            resolve(response);
          }
        })

        // Remove the access token anyway
        .catch(() => {
          localStorage.removeItem('access-token');
          delete axios.defaults.headers.common.Authorization;
        });
      commit('logout');
    })

  }
};
